import React, { useContext } from 'react';
import { CategoryNav } from '@core-ui/category-nav';
import { TagLinkGroup } from '@core-ui/tag-link-group';
import { StitchInverseStyleProvider } from '@core-ui/react-stitch';
import { useLocalize } from '@core-ui/localization-provider';
import { useBRColors23 } from '../../hooks/br-colors-2023.hook';
import { PageDataContext } from '../../providers/page-data-provider';
import { useMobile } from '../../hooks/mobile.hook';
import { useBRRedesign } from '../../hooks/br-redesign.hook';
import getCategoryNavStyles from './styles/get-category-nav-styles';
import getTagLinkGroupStyles from './styles/get-tag-link-group-styles';

type DivisionNavProps = {
  position?: string
};

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const DivisionNav = (_props: DivisionNavProps): JSX.Element => {
  const { navData } = useContext(PageDataContext);
  const { localize } = useLocalize();
  const isBRRedesign = useBRRedesign();
  const isMobileStyle = useMobile();
  const isBRColorChange = useBRColors23();

  if (isBRRedesign) {
    return (
      <StitchInverseStyleProvider>
        <TagLinkGroup
          className="tag-link-group"
          heading={localize('tag_link_group.header_label') || ''}
          links={navData}
          tagLinkGroupCSS={getTagLinkGroupStyles(isBRColorChange)}
        />
      </StitchInverseStyleProvider>
    );
  }

  return (
    <div className="nav-container" css={getCategoryNavStyles({ isMobileStyle })}>
      <CategoryNav
        categoryNavData={[{ header: '', children: navData }]}
        skipLinkHREF={isMobileStyle ? '.copyblock' : '.product-grid'}
      />
    </div>
  );
};

export default DivisionNav;
